import type { ArrayBinaryOperator, NumberOperator, StringOperator } from "@skilitics/judy";
import { booleanOperators, numberOperators, numberTernaryOperators, Operator, stringOperators } from "@skilitics/judy";

const includesOperator = (operators: readonly Operator[], operator: Operator | "" | undefined) =>
  !!operator && operators.includes(operator);

export const isBooleanOperator = (operator?: Operator) => includesOperator(booleanOperators, operator);

export const isNumberOperator = (operator?: Operator) => includesOperator(numberOperators, operator);

export const isStringOperator = (operator?: Operator) => includesOperator(stringOperators, operator);

export const isTernaryOperator = (operator?: NumberOperator | "") => includesOperator(numberTernaryOperators, operator);

// Note: This is probably only applicable to English, as other languages structure
// their sentences differently. Revisit when we release Designer in other languages.
export const operatorToEnglish = (operator?: NumberOperator | StringOperator | ArrayBinaryOperator) => {
  switch (operator) {
    case Operator.EQ:
      return "is";
    case Operator.NE:
      return "is not";
    case Operator.GT:
      return "is greater than";
    case Operator.GTE:
      return "is greater than or equal to";
    case Operator.LT:
      return "is less than";
    case Operator.LTE:
      return "is less than or equal to";
    case Operator.Between:
      return "is between";
    case Operator.NotBetween:
      return "is not between";
    case Operator.Contains:
      return "contains";
    case Operator.NotContains:
      return "does not contain";
    case Operator.Matches:
      return "matches";
    case Operator.NotMatches:
      return "does not match";
    case Operator.Has:
      return "has";
    case Operator.NotHas:
      return "does not have";
    case Operator.First:
      return "first is";
    case Operator.Last:
      return "last is";
    case Operator.MatchesFirst:
      return "first matches";
    case Operator.MatchesLast:
      return "last matches";
    default:
      return operator;
  }
};
